import React from 'react';

import { Box, Flex, Title, Tooltip, useMantineTheme } from '@mantine/core';
import { IconInfoSquareRounded } from '@tabler/icons-react';

interface ExtractedItemsNavigationHeaderProps {
  title: string;
  tooltip: string;
}

export function ExtractedItemsNavigationHeader({ title, tooltip }: ExtractedItemsNavigationHeaderProps) {
  const theme = useMantineTheme();

  return (
    <Box p="16px 16px 0px">
      <Flex justify="space-between" align="center">
        <Title order={4} size={18} fw={600}>
          {title}
        </Title>
        <Tooltip w={300} multiline label={tooltip}>
          <IconInfoSquareRounded size={16} color={theme.colors.gray[6]} />
        </Tooltip>
      </Flex>
    </Box>
  );
}
